// Libs
import React, { ReactElement } from 'react';
import clsx from 'clsx';
import { IconButton } from 'ui-components';
import { IconButtonProps } from 'ui-components';
// App
import styles from './form-control-end-button.module.scss';

/**
 * Displays a button at end of form control
 * @param props
 */
const FormControlEndButton = (props: IconButtonProps): ReactElement => {
  return (
    <IconButton
      color="primary"
      type="submit"
      {...props}
      className={clsx(styles.button, props.className)}
      size="large"
    ></IconButton>
  );
};

export default FormControlEndButton;
